import { Component, createRef } from 'react';
import autoBind from 'react-autobind';
import classNames from 'classnames/bind';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import SentimentsSvc from '../../../../services/dbServices/SentimentsSvc';

import handleTopicSelectSentimentTag from '../../../../helpers/handleTopicSelectSentimentTag';

import Scrollable from '../../../Shared/Scrollable';
import SentimentModal from './SentimentModal';
import Preloader from '../../../Preloader';
import SentimentTag from './SentimentTag';

import Styles from './styles.module.scss';
import convertPermalinkToPath from '../../../../helpers/urlHelpers';

const cx = classNames.bind(Styles);

class SentimentTags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sentimentList: {
        loading: true,
        positiveItems: [],
        negativeItems: [],
      },
      selectedTopic: null,
    };

    autoBind(this);
    this.cfMainWrapper = null;
    this.sentimentContentRef = createRef();
  }

  componentDidMount() {
    this.cfMainWrapper = document.querySelector('.cf-main-wrapper');
    this.generateListData();
  }

  componentDidUpdate(prevProps) {
    const { entityId, activePeriod } = this.props;

    if (entityId !== prevProps.entityId || activePeriod !== prevProps.activePeriod) {
      this.generateListData();
    }
  }

  async callListingsAPI(params) {
    try {
      const { data } = await SentimentsSvc.getListingsSentiments(params);
      return data;
    } catch (e) {
      console.log(e);
    }
    return { };
  }

  async generateListData() {
    const {
      entityType,
      entityId,
      isAssetClass,
      activePeriod,
    } = this.props;

    this.setState({
      sentimentList: {
        loading: true,
        noData: false,
        positiveItems: [],
        negativeItems: [],
      },
    });

    const params = {
      entity_type: entityType,
      per_page: 25,
      sorting: 'ascending',
      period: activePeriod,
      sentiment_filter_mode: 'range',
    };

    if (isAssetClass) {
      params.entity_type = 'AssetClass';
      params.entity_id = entityId;
      params.selection_mode = 'children';
    }

    Promise.all([
      this.callListingsAPI({
        ...params,
        sorting: 'descending',
        sentiment_greater_than_or_equal_to: '0',
        sentiment_less_than_or_equal_to: '100',
      }),
      this.callListingsAPI({
        ...params,
        sentiment_greater_than_or_equal_to: '-100',
        sentiment_less_than_or_equal_to: '-1',
      }),
    ])
      .then((response) => (
        response.map((data) => data.list || [])
      ))
      .then(([
        dataPositive,
        dataNegative,
      ]) => {
        this.setState({
          sentimentList: {
            loading: false,
            noData: !dataPositive.length && !dataNegative.length,
            positiveItems: dataPositive,
            negativeItems: dataNegative,
          },
        });
      });
  }

  async handleTopicRedirect(selectedTopic) {
    const { history } = this.props;
    history.push(convertPermalinkToPath(selectedTopic.permalink));
  }

  handleTopicSelectMethod(event, topic) {
    const { promoHeight, isSectors } = this.props;

    const passedProps = {
      event,
      topic,
      handleTopicRedirect: this.handleTopicRedirect.bind(this),
      width: window.innerWidth,
      promoHeight,
      isSectors,
    };
    const { query, selectedTopic } = handleTopicSelectSentimentTag(passedProps);

    if (query || selectedTopic) {
      this.setState({
        query,
        selectedTopic,
      });
    }
  }

  handleModalClose() {
    this.setState({
      selectedTopic: null,
      query: '',
    });
  }

  render() {
    const {
      activePeriod, width, promoHeight,
      chatbot,
    } = this.props;
    const { sentimentList, selectedTopic, query } = this.state;

    return (
      <div className={Styles['sentiment-tags']}>
        <Scrollable
          wrapperClassName={Styles['sentiment-tags-slider']}
          arrowClass={Styles['sentiment-tags-slider-arrow']}
        >
          <div
            ref={this.sentimentContentRef}
            className={cx('sentiment-tags-content')}
          >
            {sentimentList.loading ? (
              <Preloader loading top="unset" />
            ) : (
              <>
                {!sentimentList.loading && sentimentList.noData ? (
                  <div className={Styles['sentiment-tags-content-no-data']}>
                    No data found for this time period. Try a longer period.
                  </div>
                ) : (
                  <>
                    {[
                      sentimentList.positiveItems, sentimentList.negativeItems,
                    ].map((items, index) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <div key={index} className={Styles['sentiment-tags-items']}>
                        {!sentimentList.loading && !items.length && (
                          <div className={Styles['sentiment-tags-content-no-data']}>
                            {index === 0 ? (
                              <>
                                This time period doesn&apos;t look so good.
                                No positive sentiment to show.
                              </>
                            ) : (
                              <>
                                This time period looks great! No negative sentiment to show.
                              </>
                            )}
                          </div>
                        )}
                        {items.map((item) => (
                          <SentimentTag
                            key={item.entity_id}
                            item={item}
                            selectedTopic={selectedTopic}
                            handleTopicSelect={(e) => this.handleTopicSelectMethod(e, item)}
                            width={width}
                            promoHeight={promoHeight}
                            chatbot={chatbot}
                          />
                        ))}
                      </div>
                    ))}
                  </>
                )}
              </>
            )}
          </div>
        </Scrollable>
        {selectedTopic && (
          <SentimentModal
            isTopic
            activePeriod={activePeriod}
            slugType={selectedTopic.entity_type}
            topicId={selectedTopic.entity_id}
            topicName={selectedTopic.entity_name}
            x={selectedTopic.x}
            y={selectedTopic.y}
            arrowLeft={selectedTopic.arrowLeft}
            sentimentContentRef={this.sentimentContentRef}
            handleModalClose={this.handleModalClose}
            query={query}
            parentSentiment={selectedTopic.sentiment}
            chatbot={chatbot}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ common, promobar, chatbot }) => ({
  width: common.width,
  isChatbotOpened: chatbot.isChatbotOpened,
  promoHeight: promobar.height || 0,
});

export default connect(mapStateToProps)(withRouter(SentimentTags));
